import React from "react";
import { Link } from "react-router-dom";
import DEFAULT_ROUTES from "../../constants/routes";

const Footer = () => {
  return (
    <footer className="border-t border-border/30 py-16 px-4 relative">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <img
              src="/image.png"
              alt="QA Path"
              className="h-9 w-9 object-contain"
            />
            <div>
              <span className="font-display font-semibold text-foreground block tracking-tight">
                QA Path
              </span>
              <span className="text-xs text-muted-foreground/70">
                AI-Powered Testing
              </span>
            </div>
          </div>

          <div className="flex items-center gap-1">
            {[
              { label: "Products", href: "#products" },
              { label: "Services", href: "#services" },
              { label: "Pricing", href: "#pricing" },
              { label: "Contact", href: "#contact" },
              { label: "Docs", href: "/docs" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 px-4 py-2 rounded-lg hover:bg-secondary/30"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-border/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground/60">
            © {new Date().getFullYear()} QA Path. Powered by Alternative Path.
            All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to={DEFAULT_ROUTES.PRIVACY}
              className="text-xs text-muted-foreground/60 hover:text-foreground transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to={DEFAULT_ROUTES.TERMS}
              className="text-xs text-muted-foreground/60 hover:text-foreground transition-colors duration-200"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

